import { faEdit, faPlusSquare } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { camelCase } from "lodash-es";
import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { OPTIONS_DATA_MAPPER } from "../../utils";
import AddToolTip from "../AddToolTip";
import "../../styles/components/BankDetails.scss";
import { isEmpty, get } from "lodash";

const PayeeDetailsCard = (props) => {
  const { d, i } = props;
  const getdistributionType = (distributionMode) => {
    switch (distributionMode) {
      case 1:
        return "Cash";
        break;
      case 2:
        return "Traditional IRA";
        break;
      case 3:
        return "Roth IRA";
        break;
      case 4:
        return "Employer Sponsored";
        break;
    }
  };

  return (
    <>
      <div
        style={{
          width: "80%",
          border: "1px solid #D1CFCF",
          borderRadius: "5px",
          padding: "40px",
          marginBottom: "25px",
        }}
      >
        <div
          style={{
            fontSize: "16px",
            fontWeight: "500",
            color: "#333333",
            marginBottom: "10px",
          }}
        >
          {d.paymentMethod == 1
            ? `${getdistributionType(
                d.distributionMode
              )} - Mail Check To Address`
            : `${getdistributionType(
                d.distributionMode
              )} - EFT ( Electronic fund transfer)`}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "20px",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#F5F5F5",
            width: "100%",
            height: "64px",
            border: "1px solid #E8E8E8",
            borderRadius: "5px",
            marginBottom: "15px",
          }}
        >
          {d.paymentMethod == 2 ? (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "12px",
                    color: "##777777",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  Account Holder
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#333333",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  {d.bankInformation?.accountHolderName}
                </p>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "12px",
                    color: "##777777",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  Bank Name
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#333333",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  {d.bankInformation?.nameOfTheFinancialInstitution}
                </p>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "12px",
                    color: "##777777",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  Routing No
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#333333",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  {d.bankInformation?.abaRoutingNumberforBankOfCreditUnion}
                </p>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "12px",
                    color: "##777777",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  Account No
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#333333",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  {d.bankInformation?.abaRoutingNumberforBankOfCreditUnion}
                </p>
              </div>
            </>
          ) : (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "12px",
                    color: "##777777",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  Check Mailed To
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#333333",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  {d.address?.checkPayableTo}
                </p>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p
                  style={{
                    fontWeight: "400",
                    fontSize: "12px",
                    color: "##777777",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  Address
                </p>
                <p
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#333333",
                    padding: "0px",
                    margin: "0px",
                  }}
                >
                  {d.address?.address1 && d.address?.address1 + ","}
                  {d.address?.city && d.address?.city + ","}
                  {d.address?.state && d.address?.state + ","}
                  {d.address?.zipCode && d.address?.zipCode + ","}
                  {d.address?.country && d.address?.country}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PayeeDetailsCard;
